import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
//assets
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "simplebar/dist/simplebar.min.css";
import MetisMenu from "metismenujs";
import PrivateRoute from "./components/PrivateRoute";
// and initialize with useEffect if needed

// If you're using ApexCharts
// import ApexCharts from "apexcharts";
//Pages
import Login from "./pages/Login";
import Main from "./layouts/Main";
import SelectContext from "./pages/SelectContext";
import Dashboard from "./pages/Dashboard";
import Ledger from "./pages/Ledger";
import Grouping from "./pages/Grouping";
import ReportGroupSettings from "./pages/ReportGroupSettings";
import Transaction from "./pages/Transaction";
import OpenbalanceList from "./pages/OpenbalanaceList";
import MonthlyInvoice from "./pages/MonthlyInvoice";
import OtherInvoice from "./pages/OtherInvoice";
import OnboardProcess from "./pages/OnboardProcess";
import CustomerList from "./pages/CustomerList";
import LedgerStatement from "./pages/LedgerStatement";
import HistoryLog from "./pages/HistoryLog";
import TrialBalance from "./pages/TrialBalance";
import ProfitLoss from "./pages/ProfitLoss";
import BalanceSheet from "./pages/BalanceSheet";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Public Route */}
          <Route path="/" element={<Login />} />
          {/* Private Routes */}
          <Route path="/" element={<Main />}>
            <Route element={<PrivateRoute />}>
              <Route path="/select-context" element={<SelectContext />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/MonthlyInvoice" element={<MonthlyInvoice />} />
              <Route path="/OtherInvoice" element={<OtherInvoice />} />
              <Route path="/OnboardProcess" element={<OnboardProcess />} />
              <Route path="/CustomerList" element={<CustomerList />} />
              <Route path="/transaction" element={<Transaction />} />
              <Route path="/ledger" element={<Ledger />} />
              <Route path="/grouping" element={<Grouping />} />
              <Route path="/report-group-settings" element={<ReportGroupSettings />} />
              <Route path="/open-balance-list" element={<OpenbalanceList />} />
              <Route path="/statement-ledger" element={<LedgerStatement />} />
              <Route path="/history-log" element={<HistoryLog />} />
              <Route path="/trial-balance" element={<TrialBalance />} />
              <Route path="/profit-loss" element={<ProfitLoss />} />
              <Route path="/balance-sheet" element={<BalanceSheet />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
